var _style, _desc, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysisIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 54",
    style: {
      enableBackground: "new 0 0 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#Oval-Copy-4_1_);}\n\t.st1{fill:none;stroke:#262262;stroke-width:0.5225;stroke-linecap:round;stroke-linejoin:round;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "HOMEPAGE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-v4",
    transform: "translate(-542.000000, -106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(542.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oval-Copy-4_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -167.2149,
    y1: 175.2099,
    x2: -174.549,
    y2: 175.4156,
    gradientTransform: "matrix(54 0 0 -54 9116 9490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73BCE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5847,
    style: {
      stopColor: "#75C6A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDD883"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    className: "st0",
    cx: 27,
    cy: 27,
    r: 27
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teacher",
    transform: "translate(10.647887, 10.267606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M16.2,17.2v7.5V17.2z M24.7,17.7l-5.7-2.9l5.8-11.3l5.7,2.9L24.7,17.7z M30.5,1.4l-1.7-0.9 c-1.1-0.6-2.4-0.1-3,1l-1,2l5.7,2.9l1-2c0.3-0.5,0.3-1.1,0.1-1.7C31.4,2.1,31.1,1.6,30.5,1.4L30.5,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M19.1,14.8l0,5.8c0,0.5,0.6,0.8,1,0.5l4.7-3.5L19.1,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.5,9.9c-4.7,1.8-5.4,4.4-5.4,4.4s-1.4-6-15.9-6v13.4c0,0,12.2-0.3,14.8,7.3h2.2 c2.5-7.5,14.8-7.3,14.8-7.3V8.4c-0.9,0-1.8,0-2.6,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.3,29H15c-2.5-7.5-14.8-7.3-14.8-7.3v3.2c0,0,10.3-0.3,12.9,7.3h6c2.5-7.5,12.9-7.3,12.9-7.3v-3.2 C32.1,21.7,19.8,21.4,17.3,29L17.3,29z M3.5,11.8c0,0,6.2-0.1,9.3,3.1L3.5,11.8z M3.5,19c0,0,6.2-0.1,9.3,3.1L3.5,19z M3.5,15.4 c0,0,6.2-0.1,9.3,3.1L3.5,15.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisIcon);
export default __webpack_public_path__ + "static/media/analysis-icon.e8a8dcfc8706ae704cbc6460c7f20b8c.svg";
export { ForwardRef as ReactComponent };